import * as React from 'react';
import Card from "../card/card";

import { Watch } from 'scrollmonitor-react';

import './articleList.scss';

class ArticleList extends React.Component {
  render() {
    let theBlock = this.props.block;
    let tmpArticle = [];
    let tmpArticles = [];
    let baseUrl = this.props.baseUrl ? this.props.baseUrl : ".";
    let inView = this.props.isInViewport;
    let elementHasBeenInView = this.props.isAboveViewport;
 
    // Change classname based on boolean
    let viewClassName = (inView)? 'is-inview-true' : 'is-inview-false';
    let beenViewed = (elementHasBeenInView)? ' is-viewed' : ' is-not-viewed';

    //populate new article array with all article data
    this.props.block.blockListArticles.forEach(function(item) {
        var indexOfArticleData = this.props.issueArticles.map(function(o) { return o.articleId; }).indexOf(item.articleId);
        tmpArticles.push(this.props.issueArticles[indexOfArticleData]);
    }, this);

    if(this.props.block){
        tmpArticle = tmpArticles.map(function(article, key) {
            return (
                <Card renderImage={true} smallCard={true} key={"card_"+article.articleId+key} hideImageOnMobile={true} baseUrl={baseUrl} issueId={this.props.issueId} cardData={article} changeRoute={this.props.changeRoute} locale={this.props.locale}/>
            )
        }, this);
    }

    if(!this.props.block) {
        return ""
    } else {
        return (
            <div className={theBlock.blockHideOnMobile ? viewClassName + beenViewed + " d-none d-md-block " + theBlock.blockType : viewClassName + beenViewed + " " + theBlock.blockType}> 
                <div className="container">
                    <div className="row">
                        <div className="col-12 my-sm-4">
                            {!theBlock.blockTitle | !theBlock.blockSummary &&
                            <div className="row">
                                <div className="col-md-12">
                                    {theBlock.blockTitle ? <h2 className="block-title">{theBlock.blockTitle}</h2> : ""}
                                    {theBlock.blockSummary ? <div className="block-summary"><p>{theBlock.blockSummary}</p></div> : ""}
                                </div>
                            </div>
                            } 
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card-deck">
                                        {tmpArticle}
                                    </div>
                                </div>
                            </div>
                            {theBlock.blockFooter !== "" &&
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="block-footer">{theBlock.blockFooter}</div>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
  }
}

//const InviewOptions = {offsetY: 0.2, showGuides: false, fullElementInView: false, debounceTime: 30}

export default Watch(ArticleList);
